export default __webpack_public_path__ + "static/media/Gerry - 3155.9e09ed70.jpeg";